module.exports = __webpack_public_path__ + "img/qrCode_01.32bfc71f.jpg";